export const iconRowWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: 'text.secondary',
};
